import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { ServerAction } from '../server.action';

type IDependencies = IClientApiDependencySegment;

export const generateServerSecretEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ServerAction.generateSecret.started),
  mergeMap((payload) =>
    dependencies.api.generateServerSecret(payload).pipe(
      mergeMap((response) => {
        payload.resolve?.(response?.secret);
        return [ServerAction.generateSecret.done({ params: payload, result: response })];
      }),
      catchApiError((error) => {
        const isHandled = payload.reject?.(error?.errorCode, error?.description, error?.params);
        return [
          ServerAction.generateSecret.failed({ params: payload, error }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    ),
  ),
);
